import {
  cardTitle,
  grayColor
} from "assets/jss/material-dashboard-pro-react.jsx";

const userProfileStyles = theme => ({
  cardTitle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
    "& small": {
      fontSize: "80%",
      fontWeight: "400"
    }
  },
  cardCategory: {
    marginTop: "10px",
    color: theme.palette.text.page + " !important",
    textAlign: "center"
  },
  description: {
    color: theme.palette.text.page,//grayColor[0]
  },
  updateProfileButton: {
    float: "right"
  }
});
export default userProfileStyles;
